import axios from 'axios'

export const state = {
  cachedUsers: null,
  selectedUser: null,
}

export const getters = {
  cachedUsers(state) {
    return state.cachedUsers
  },
  selectedUser(state) {
    return state.selectedUser
  },
}

export const mutations = {
  CACHED_USERS(state, users) {
    state.cachedUsers = users
  },
  SET_SELECTED(state, user) {
    state.selectedUser = user
  },
}

export const actions = {
  selectUser({ commit, state, rootState }, { user }) {
    commit('SET_SELECTED', user)
  },

  fetchUsers({ commit, state, rootState }) {
    // Fetch the user from the API and cache it in case
    //  we need it again in the future.
    return axios.get('/api/services/app/User/GetAll').then((response) => {
      const users = response.data.items
      commit('CACHED_USERS', users)
      return users
    })
  },

  createUser({ commit, dispatch, state, rootState }, { user }) {
    return axios
      .post('/api/services/app/User/Create', user)
      .then((response) => {
        dispatch('fetchUsers', { clearCache: true })
      })
      .catch((error) => {
        if (error.response && error.response.status === 401) {
          // commit('SET_CACHE', null)
        }
        return null
      })
  },

  updateUser({ commit, dispatch, state, rootState }, { user }) {
    return axios
      .put('/api/services/app/User/Update', user)
      .then((response) => {
        dispatch('fetchUsers', { clearCache: true })
      })
      .catch((error) => {
        if (error.response && error.response.status === 401) {
          // commit('SET_CACHE', null)
        }
        return null
      })
  },

  changePassword({ commit, dispatch, state, rootState }, { password }) {
    return axios
      .post('/api/services/app/User/ChangePassword', password)
      .then((response) => {
        dispatch('fetchUsers', { clearCache: true })
      })
      .catch((error) => {
        if (error.response && error.response.status === 401) {
          // commit('SET_CACHE', null)
        }
        return null
      })
  },
}
